var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg024Handrail = function Svg024Handrail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361 421H241v-60H121v-60H0v211h361zM0 181h91v90H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M331 391V280.272l-90-45V331h30v60zM211 331V220.272L132.455 181H121v90h30v60z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 151h139.545l286.582 143.291C441.464 301.967 451 317.392 451 334.545V361h-30v-26.455c0-5.728-3.179-10.869-8.291-13.418L361 295.272V391h30v121h121V0H0zm301-30V61h90v60h51.211L346 217.211 249.789 121z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M369.789 151H361V91h-30v60h-8.789L346 174.789z"
  })));
};
export default Svg024Handrail;